import React, { useState } from 'react';
import Layout from '../components/Layout';
import logo from '../assets/logo.png';
import '../stylings/Login.css';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '', role: 'student' });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    // [PLACEHOLDER: Connect to ERP backend authentication API]
    alert('ERP Login – Connect to backend API');
  };

  return (
    <Layout bannerTitle="ERP Login">
      <section className="login-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-7">
              <div className="login-card">
                <div className="login-logo-wrapper">
                  <img src={logo} alt="Akash Model School" className="login-logo" />
                  <h4>Akash Model School</h4>
                  <p>ERP Portal Login</p>
                </div>
                <form onSubmit={handleSubmit} className="login-form">
                  <div className="mb-3">
                    <label className="form-label">Login As</label>
                    <select name="role" className="form-select" value={form.role} onChange={handleChange}>
                      <option value="student">Student</option>
                      <option value="parent">Parent</option>
                      <option value="teacher">Teacher</option>
                      <option value="admin">Admin</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Username / Roll No.</label>
                    <input type="text" name="username" className="form-control" placeholder="Enter username" value={form.username} onChange={handleChange} required />
                  </div>
                  <div className="mb-4">
                    <label className="form-label">Password</label>
                    <input type="password" name="password" className="form-control" placeholder="Enter password" value={form.password} onChange={handleChange} required />
                  </div>
                  <button type="submit" className="login-submit-btn w-100">
                    <i className="fas fa-sign-in-alt me-2"></i>Login
                  </button>
                </form>
                <div className="login-footer-links">
                  <a href="/contact">Need Help?</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
